export const pageTitle = title => {
  return (document.title =
    title + ' - Freedom Prosthetics LLC');
};
